export default{
    set_search_records(comtext,search_val) {
        let records = comtext.state.search_records.find(v => {
            return v == search_val
        })
        if (!records) {
            comtext.commit('search_records',search_val)
        }

        // return new Promise(resolve => {
        //     let records = comtext.state.search_records.find(v => {
        //         return v == search_val
        //     })
        //     if (!records) {
        //         comtext.commit('search_records',search_val)
        //         resolve("添加成功")
        //     }
        // })
    }
}


// WEBPACK FOOTER //
// ./src/store/actions.js